import { englishDomTheme } from "../englishdom/theme.config.js";
const assetBase = "/assets/quizzes/englishdom";
const lessonScore = { lesson: 1 };
export const instagramLessonQuiz = {
    id: "englishdom-instagram-lesson",
    slug: "instagram-lesson",
    version: 1,
    metadata: {
        name: "Englishdom",
        language: "uk",
        description: "Чотири короткі питання перед записом на безкоштовний пробний урок.",
        pageTitle: "Безкоштовний пробний урок англійської | Englishdom"
    },
    presentation: {
        flowLayout: "compact",
        entryComposition: "offer-cards",
        questionTransition: "fade-y",
        counter: { enabled: true, totalSteps: 4 },
        skipAnalysis: true,
        questionEchoes: {
            goal: {
                sourceQuestionId: "status",
                template: "Окей, {value}. Тепер — про твою мету.",
                values: {
                    start: "починаєш з нуля",
                    return: "повертаєшся після паузи",
                    understand: "дещо розумієш, але говорити складно",
                    use: "вже використовуєш англійську"
                }
            },
            blocker: {
                sourceQuestionId: "goal",
                template: "Зафіксували: англійська потрібна {value} 🎯 А тепер — про труднощі.",
                values: {
                    work: "для роботи й кар'єри",
                    travel: "для подорожей",
                    people: "для спілкування",
                    study: "для навчання чи іспитів",
                    media: "для фільмів і книжок в оригіналі",
                    self: "для себе"
                }
            },
            practice_preference: {
                sourceQuestionId: "blocker",
                template: "Зрозуміло: «{value}». Залишилося одне питання 💚",
                values: {
                    speaking: "Складно говорити",
                    listening: "Важко розуміти на слух",
                    vocab: "Бракує слів",
                    grammar: "Плутаюся в граматиці",
                    start: "Не знаю, з чого почати",
                    habit: "Не вистачає регулярності"
                }
            }
        },
        booking: {
            url: "https://englishdom.com/selfbooking/",
            source: "external",
            level: "1",
            goalQuestionId: "goal",
            blockerQuestionId: "blocker",
            title: "Твій фокус уже вимальовується 👀",
            goalLabel: "Твоя мета",
            blockerLabel: "Хочеться покращити",
            introduction: "Залишилося обрати зручний час. Залиш свої контакти нижче — вони автоматично врахуються при записі на заняття.",
            afterFormNote: "Далі обереш зручний час. Повторно вводити контакти не потрібно."
        }
    },
    startQuestionId: "status",
    landing: { enabled: false, sections: [] },
    start: {
        enabled: true,
        renderer: "native",
        mode: "first-question",
        layout: "split-question",
        eyebrow: "Почнімо знайомство",
        title: "Запишись на безкоштовний пробний урок англійської 💚",
        subtitle: "Познайомся з викладачем, дізнайся свій рівень і спробуй навчання на платформі.\n\nВідповідай на 4 короткі питання, щоб ми врахували твої цілі. А потім обереш зручний час.",
        cta: { label: "Почати", action: "startQuiz" },
        note: "4 короткі питання · далі вибір часу",
        background: { type: "color", value: "#54CA87" },
        logo: { enabled: true, src: `${assetBase}/logo-white.png`, alt: "Englishdom" }
    },
    progress: { mode: "linear" },
    phone: { defaultCountry: "UA", preferredCountries: ["UA", "PL", "DE", "CZ", "US", "CA"], searchable: true },
    questions: [
        {
            id: "status", type: "single-choice", title: "Як у тебе зараз з англійською?",
            answers: [
                { id: "start", emoji: "🌱", label: "Починаю з нуля", next: "goal", scores: lessonScore },
                { id: "return", emoji: "🔄", label: "Повертаюся після паузи", next: "goal", scores: lessonScore },
                { id: "understand", emoji: "👀", label: "Щось розумію, але говорити складно", next: "goal", scores: lessonScore },
                { id: "use", emoji: "💬", label: "Уже використовую, хочу впевненіше", next: "goal", scores: lessonScore }
            ]
        },
        {
            id: "goal", type: "single-choice", title: "Для чого тобі англійська найбільше зараз?",
            answers: [
                { id: "work", emoji: "💼", label: "Для роботи й кар’єри", next: "blocker", scores: lessonScore },
                { id: "travel", emoji: "✈️", label: "Для подорожей", next: "blocker", scores: lessonScore },
                { id: "people", emoji: "🗣️", label: "Для спілкування з людьми", next: "blocker", scores: lessonScore },
                { id: "study", emoji: "🎓", label: "Для навчання чи іспитів", next: "blocker", scores: lessonScore },
                { id: "media", emoji: "🎬", label: "Фільми, відео й книжки в оригіналі", next: "blocker", scores: lessonScore },
                { id: "self", emoji: "💚", label: "Для себе", next: "blocker", scores: lessonScore }
            ]
        },
        {
            id: "blocker", type: "single-choice", title: "Що зараз найбільше заважає тобі в англійській?",
            answers: [
                { id: "speaking", emoji: "💬", label: "Складно говорити", next: "practice_preference", scores: lessonScore },
                { id: "listening", emoji: "🎧", label: "Важко розуміти на слух", next: "practice_preference", scores: lessonScore },
                { id: "vocab", emoji: "🧩", label: "Бракує слів", next: "practice_preference", scores: lessonScore },
                { id: "grammar", emoji: "📝", label: "Плутаюся в граматиці", next: "practice_preference", scores: lessonScore },
                { id: "start", emoji: "🚀", label: "Не знаю, з чого почати", next: "practice_preference", scores: lessonScore },
                { id: "habit", emoji: "⏰", label: "Не вистачає регулярності", next: "practice_preference", scores: lessonScore }
            ]
        },
        {
            id: "practice_preference", type: "single-choice", title: "Як тобі було б найцікавіше практикувати англійську?",
            answers: [
                { id: "dialogue", emoji: "💬", label: "Більше говорити на цікаві теми", next: "__end__", scores: lessonScore },
                { id: "real_cases", emoji: "🎭", label: "Розбирати ситуації з реального життя", next: "__end__", scores: lessonScore },
                { id: "video", emoji: "🎬", label: "Вчитися через відео та живі фрази", next: "__end__", scores: lessonScore },
                { id: "exercises", emoji: "🧩", label: "Робити короткі вправи з поясненнями", next: "__end__", scores: lessonScore },
                { id: "unsure", emoji: "🤔", label: "Поки не знаю — хочу спробувати", next: "__end__", scores: lessonScore }
            ]
        }
    ],
    scoring: { categories: ["lesson"], tieBreaker: ["lesson_ready"] },
    results: [{
            id: "lesson_ready", category: "lesson", title: "Підготовка до пробного уроку",
            description: "Ми врахували твої відповіді для наступного кроку.",
            preview: "Обери зручний час уроку.", gatedContent: "Обери зручний час уроку."
        }],
    analysis: { durationMs: 0, steps: [], checkpoints: [] },
    leadForm: {
        title: "Залиш контакти",
        placement: "inline-result",
        fields: {
            name: { enabled: true, required: true, label: "Ім’я" },
            phone: { enabled: true, required: true, label: "Телефон" },
            email: { enabled: true, required: true, label: "Email" }
        },
        privacyConsentRequired: true,
        marketingConsentEnabled: true,
        submitLabel: "Обрати час безкоштовного уроку"
    },
    integrations: { googleSheets: { enabled: true, questionHeaderMode: "question_ids" } },
    uiCopy: {
        privacyConsent: "Погоджуюся з політикою конфіденційності",
        marketingConsent: "Хочу отримувати корисні повідомлення про навчання",
        sending: "Зберігаємо заявку..."
    },
    theme: englishDomTheme
};
